import Layout from './components/layout/Layout';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <Layout>
      <LandingPage />
    </Layout>
  );
}

export default App;
